import { render, staticRenderFns } from "./DialogCommunication.vue?vue&type=template&id=f55b37fe"
import script from "./DialogCommunication.vue?vue&type=script&lang=js"
export * from "./DialogCommunication.vue?vue&type=script&lang=js"
import style0 from "./DialogCommunication.vue?vue&type=style&index=0&id=f55b37fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports